fTA<template>
  <div class="atividades-escalaservicos ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->
        <b-col cols="3">
          <label for="select-empresa">Empresa</label>
          <multiselect
            id="selecao-empresa-sol"
            v-model="valor_empresa"
            required
            :options="empresas"
            :multiple="true"
            :close-on-select="false"
            :clear-on-select="false"
            @close="loadFiliais()"
            :preserve-search="true"
            placeholder="Selecione a empresa"
            label="empresa"
            track-by="empresa"
            name="empresa"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Empresa selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <b-col cols="2">
          <label for="select-garagem_sol">Filial</label>
          <multiselect
            id="selecao-filial-sol"
            v-model="valor_filial"
            required
            :options="filiais"
            :multiple="true"
            :taggable="true"
            @close="loadLote()"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Selecione a filial"
            label="filial"
            track-by="filial"
            name="filial"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Filial selecionada</span
              ></template
            >
          </multiselect>
        </b-col>

        <!-- Lote-->
        <b-col cols="1">
          <label for="select-lote">Lote</label>
          <multiselect
            id="selecao-lote"
            v-model="valor_lote"
            required
            :options="lotes"
            :multiple="true"
            :taggable="true"
            @close="loadLinhas()"
            @tag="addTag"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Lote"
            label="lote"
            track-by="lote"
            name="lote"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Lote selecionado</span
              ></template
            >
          </multiselect>
        </b-col>

        <!-- Linha-->
        <b-col cols="1">
          <label for="select-status">Linha</label>
          <multiselect
            id="selecao-status-sol"
            v-model="valor_linha"
            required
            :options="linhas"
            :multiple="true"
            :taggable="true"
            @close="loadStatus()"
            @tag="addTag"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Linha(s)"
            label="linha"
            track-by="linha"
            name="linha"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} Linha(s) selecionada(s)</span
              ></template
            >
          </multiselect>
        </b-col>

        <!-- Status-->
        <b-col cols="2">
          <label for="select-status">Status</label>
          <multiselect
            id="selecao-status-sol"
            v-model="valor_status"
            required
            :options="statuss"
            :multiple="true"
            :taggable="true"
            @tag="addTag"
            :close-on-select="false"
            :clear-on-select="false"
            :preserve-search="true"
            placeholder="Status"
            label="status"
            track-by="status"
            name="status"
            :preselect-first="true"
          >
            <template slot="selection" slot-scope="{ values, isOpen }"
              ><span
                class="multiselect__single"
                v-if="values.length &amp;&amp; !isOpen"
                >{{ values.length }} status selecionado</span
              ></template
            >
          </multiselect>
        </b-col>

        <!-- Data serviço -->
        <b-col cols="2">
          <div>
            <label for="datepicker-placeholder">Data da escala</label>
            <b-form-datepicker
              id="datepicker-placeholder"
              v-model="valor_dtservico"
              required
              placeholder="Data do serviço"
              locale="pt-BR"
              date-format-options="DD/MM/YYYY"
            ></b-form-datepicker>
          </div>
        </b-col>

        <b-col cols="1" class="mt-4">
          <b-button
            size="sm"
            id="btn-pesquisar"
            variant="primary"
            block
            class="mr-2 mt-2"
            :disabled="carregando"
            @click="
              (carregando = true),
                loadEscalaServico(),
                loadEscalaServicoAlteracoes(),
                getBackgroundColor(),
                getBackgroundColorCarro(),
                getBackgroundColorCobrador()
            "
          >
            <b-spinner v-if="carregando" small style="margin-bottom: 3px">
            </b-spinner>
            Pesquisar
          </b-button>
        </b-col>

        <b-col cols="12">
          <b-row class="mt-3 ml-3">
            <!--                   -->
            <b-col cols="2">
              <b-card
                class="card-modern-left-line shadow-gradient"
                align="center"
              >
                <template #header>
                  <div class="d-flex align-items-center justify-content-center">
                    <i
                      class="fa fa-table mr-2"
                      style="font-size: 2.5em; color: #3bc480"
                    ></i>
                    <span class="card-header-text">SERVIÇO(s)</span>
                  </div>
                </template>
                <b-card-text>
                  <h2>
                    {{
                      escalaservicos.length > 0 ? escalaservicos.length : "0"
                    }}
                  </h2>
                </b-card-text>
              </b-card>
            </b-col>

            <b-col cols="2">
              <b-card
                class="card-modern-left-line shadow-gradient"
                align="center"
              >
                <template #header>
                  <div class="d-flex align-items-center justify-content-center">
                    <i
                      class="fa fa-user mr-2"
                      style="font-size: 2.5em; color: #3bc480"
                    ></i>
                    <span class="card-header-text"
                      >MOTORISTA(s) ALTERADO(s)</span
                    >
                  </div>
                </template>
                <b-card-text>
                  <h2
                    v-for="motorista in escalaservicosalteracoes"
                    :key="motorista.id"
                  >
                    {{ motorista.motorista }}
                  </h2>
                </b-card-text>
              </b-card>
            </b-col>
            <!--                   -->

            <b-col cols="2">
              <b-card
                class="card-modern-left-line shadow-gradient"
                align="center"
              >
                <template #header>
                  <div class="d-flex align-items-center justify-content-center">
                    <i
                      class="fa fa-user mr-2"
                      style="font-size: 2.5em; color: #3bc480"
                    ></i>
                    <span class="card-header-text"
                      >COBRADOR(es) ALTERADO(s)</span
                    >
                  </div>
                </template>
                <b-card-text>
                  <h2
                    v-for="cobrador in escalaservicosalteracoes"
                    :key="cobrador.id"
                  >
                    {{ cobrador.cobrador }}
                  </h2>
                </b-card-text>
              </b-card>
            </b-col>

            <!--                   -->

            <b-col cols="2">
              <b-card
                class="card-modern-left-line shadow-gradient"
                align="center"
              >
                <template #header>
                  <div class="d-flex align-items-center justify-content-center">
                    <i
                      class="fa fa-bus mr-2"
                      style="font-size: 2.5em; color: #3bc480"
                    ></i>
                    <span class="card-header-text">CARRO(s) ALTERADO(s)</span>
                  </div>
                </template>
                <b-card-text>
                  <h2 v-for="carro in escalaservicosalteracoes" :key="carro.id">
                    {{ carro.carro }}
                  </h2>
                </b-card-text>
              </b-card>
            </b-col>

            <!--                   -->

            <b-col cols="2">
              <b-card
                class="card-modern-left-line shadow-gradient"
                align="center"
              >
                <template #header>
                  <div class="d-flex align-items-center justify-content-center">
                    <i
                      class="fa fa-plus mr-2"
                      style="font-size: 2.5em; color: #3bc480"
                    ></i>
                    <span class="card-header-text">QTD DE ALTERAÇÕES(s)</span>
                  </div>
                </template>
                <b-card-text>
                  <h2
                    v-for="tabelas in escalaservicosalteracoes"
                    :key="tabelas.alteracao"
                  >
                    {{ tabelas.alteracao }}
                  </h2>
                </b-card-text>
              </b-card>
            </b-col>

            <b-col cols="2">
              <b-col class="mb-0 mt-5">
                <label for="input-busca">Pesquisa no grid </label>
                <b-form-input
                  id="buscamonitoramento"
                  v-model="search"
                  required="required"
                  placeholder="Motorista / Cobrador / Carro / Linha"
                ></b-form-input>
              </b-col>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-form>

    <b-col>
      <div>
        <b-progress class="mt-3 mp-3" :max="barra_limite">
          <b-progress-bar
            variant="success"
            :value="barra_inicial"
            :label="`${((barra_inicial / barra_limite) * 100).toFixed(2)} %`"
          ></b-progress-bar>
        </b-progress>
      </div>
    </b-col>

    <div class="d-flex justify-content-center mb-3">
      <b-spinner v-if="atualizando" label="Loading..."></b-spinner>
    </div>
    <!--tbl de dados -->
    <b-table
      id="escaladiariamonitoramento"
      small
      hover
      striped
      sticky-header="835px"
      :items="itemsFiltered"
      :fields="fieldsescaladiaria"
    >
      <template v-slot:cell(motrealizado)="data">
        <div :class="getBackgroundColor(data.item)">
          {{ data.value }}
        </div>
      </template>

      <template v-slot:cell(cobrealizado)="data">
        <div :class="getBackgroundColorCobrador(data.item)">
          {{ data.value }}
        </div>
      </template>

      <template v-slot:cell(carrorealizado)="data">
        <div :class="getBackgroundColorCarro(data.item)">
          {{ data.value }}
        </div>
      </template>

      <template slot="cell(actions)" slot-scope="data">
        <b-button
          @click="editTabela(data.item)"
          title="Alterar tabela"
          size="sm"
          variant="primary"
          class="mr-2 mt-2"
          v-b-modal.modal-multi-1
        >
          <i class="fa fa-exclamation-circle"></i>
        </b-button>
      </template>
    </b-table>

    <!--  MODAL MANUTENÇÃO DA TABELA  -->
    <!--  MODAL MANUTENÇÃO DA TABELA  -->
    <!--  MODAL MANUTENÇÃO DA TABELA  -->
    <div>
      <b-modal
        id="modal-multi-1"
        size="xl"
        title="Manutenção de tabela.:"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
      >
        <!-- -->
        <div>
          <b-row>
            <input
              id="id-sac"
              type="hidden"
              v-model="escalaservico.id_tabela"
            />

            <b-col cols="2" class="mt-5">
              <label for="input-live">Linha</label>
              <b-form-input
                id="es-linha"
                v-model="escalaservico.linha"
                readonly
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>

            <b-col cols="3" class="mt-5">
              <label for="input-live">Tabela</label>
              <b-form-input
                id="es-tabela"
                v-model="escalaservico.tabela"
                readonly
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>

            <b-col cols="3" class="mt-5">
              <label for="input-live">Inicio Serviço</label>
              <b-form-input
                id="es-jini"
                v-model="escalaservico.servico_ini"
                readonly
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>

            <b-col cols="3" class="mt-5">
              <label for="input-live">Término Serviço</label>
              <b-form-input
                id="es-jter"
                v-model="escalaservico.servico_ter"
                readonly
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>
          </b-row>

          <!-- Carro a ser alterado-->
          <b-row>
            <b-col cols="2" class="mt-5">
              <label for="input-live">Carro Atual</label>
              <b-form-input
                id="es-carroa"
                v-model="escalaservico.carroprogramado"
                readonly
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>

            <b-col cols="2" class="mt-5">
              <label for="input-live">Carro Novo</label>
              <b-form-input
                id="es-carron"
                v-model="valor_carro"
                @keyup.enter="loadVeiculo()"
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>

            <b-col cols="4" class="mt-5">
              <label for="input-live">Placa </label>
              <b-input-group-text>
                {{
                  carro.map((car) => car.placa).join(", ")
                    ? carro.map((car) => car.placa).join(", ")
                    : "-"
                }}
              </b-input-group-text>
            </b-col>

            <b-col cols="4" class="mt-5">
              <label for="es-motc">Motivo da alteração do carro</label>
              <div>
                <b-form-select
                  id="es-selec-motc"
                  v-model="escalaservico.id_motivo_carro"
                  @change="loadMotivoAlteracaoCarro()"
                  :options="motivosalteracoesCarro"
                  class="mb-3"
                  text-field="motivo"
                >
                </b-form-select>
              </div>
            </b-col>
          </b-row>

          <!-- Motorista a ser alterado-->
          <b-row>
            <b-col cols="2" class="mt-5">
              <label for="input-live">Motorista Atual</label>
              <b-form-input
                id="es-mota"
                v-model="escalaservico.motprogramado"
                readonly
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>

            <b-col cols="2" class="mt-5">
              <label for="input-live">Motorista Novo</label>
              <b-form-input
                id="es-motn"
                v-model="valor_motorista"
                @keyup.enter="loadBuscaMotorista()"
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>

            <b-col cols="4" class="mt-5">
              <label for="input-live">Motorista função</label>
              <b-input-group-text>{{
                motorista.map((mt1) => mt1.funcao).join(", ")
                  ? motorista.map((mt1) => mt1.funcao).join(", ")
                  : "-"
              }}</b-input-group-text>
            </b-col>

            <b-col cols="4" class="mt-5">
              <label for="input-parecer">Motivo da alteração motorista</label>

              <div>
                <b-form-select
                  id="es-selec-motm"
                  v-model="escalaservico.id_motivo_motorista"
                  @change="loadMotivoAlteracaoMotorista()"
                  :options="motivosalteracoesMotorista"
                  class="mb-3"
                  text-field="motivo"
                  value-field="value"
                />
              </div>
            </b-col>
          </b-row>

          <!-- Cobrador a ser alterado-->
          <b-row>
            <b-col cols="2" class="mt-5">
              <label for="input-live">Cobrador Atual</label>
              <b-form-input
                id="es-coba"
                v-model="escalaservico.cobprogramado"
                readonly
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>

            <b-col cols="2" class="mt-5">
              <label for="input-live">Cobrador Novo</label>
              <b-form-input
                id="es-cobn"
                v-model="valor_cobrador"
                @keyup.enter="loadBuscaCobrador()"
                placeholder=""
                class="mb-3 alttabela"
              ></b-form-input>
            </b-col>

            <b-col cols="4" class="mt-5">
              <label for="input-live">Cobrador função</label>
              <b-input-group-text>{{
                cobrador.map((cb) => cb.funcao).join(", ")
                  ? cobrador.map((cb) => cb.funcao).join(", ")
                  : "-"
              }}</b-input-group-text>
            </b-col>

            <b-col cols="4" class="mt-5">
              <label for="input-parecer">Motivo da alteração cobrador</label>

              <div>
                <b-form-select
                  id="es-selec-motc"
                  v-model="escalaservico.id_motivo_cobrador"
                  @change="loadMotivoAlteracaoCobrador()"
                  :options="motivosalteracoesCobrador"
                  class="mb-3"
                  text-field="motivo"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-button
              class="mt-3"
              variant="success"
              block
              @click="
                /*
                putTabelaDiaria(),
                  putTabelaDiariaPartidas(),
                  */
                putTabelaDiariaTransacao()
              "
              >Gravar</b-button
            >
          </b-row>
        </div>
      </b-modal>
    </div>
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import Multiselect from "vue-multiselect";
//import Multiselect from "primevue/multiselect"; // Importa o componente MultiSelect
import moment, { now } from "moment";
import { mapState } from "vuex";
import * as XLSX from "xlsx";

export default {
  name: "escalaservico",

  computed: {
    ...mapState(["user"]),

    motivoSelecionadoCobrador() {
      return this.motivosalteracoesCobrador.find(
        (m) => m.value === this.escalaservico.id_motivo_cobrador
      );
    },

    motivoSelecionadoMotorista() {
      return this.motivosalteracoesMotorista.find(
        (m) => m.value === this.escalaservico.id_motivo_motorista
      );
    },

    itemsFiltered() {
      let valores = [];
      valores = this.escalaservicos.filter((item) => {
        const motprogramado = item.motprogramado || ""; // devido alguns valores retornarem null se faz necessario a substituição para não dar erro no filtro
        const motrealizado = item.motrealizado || "";
        const cobprogramado = item.cobprogramado || "";
        const cobrealizado = item.cobrealizado || "";
        const carroprogramado = item.carroprogramado || "";
        const carrorealizado = item.carrorealizado || "";
        return (
          item.linha.toLowerCase().includes(this.search.toLowerCase()) ||
          item.tabela.toLowerCase().includes(this.search.toLowerCase()) ||
          item.servico_ini.toLowerCase().includes(this.search.toLowerCase()) ||
          motprogramado.indexOf(this.search) > -1 ||
          motrealizado.indexOf(this.search) > -1 ||
          cobprogramado.indexOf(this.search) > -1 ||
          cobrealizado.indexOf(this.search) > -1 ||
          carroprogramado.indexOf(this.search) > -1 ||
          carrorealizado.indexOf(this.search) > -1
        );
      });
      return valores;
    },
  },

  data: function () {
    return {
      empresa: {},
      empresas: [], // [] lista
      filial: {},
      filiais: [], // [] lista
      lotes: [],
      escalaservico: {},
      escalaservicos: [],
      linhas: [],
      valor_empresa: "",
      valor_filial: "",
      valor_lote: "",
      valor_linha: "",
      valor_status: "",
      valor_dtservico: "",
      escalaservico: {}, // [] lista
      search: "",
      motivosalteracoesCarro: [],
      motivosalteracoesCobrador: [],
      motivosalteracoesMotorista: [],
      valor_carro: "",
      valor_motorista: "",
      valor_cobrador: "",
      carro: [],
      motorista: [],
      cobrador: [],
      mode: "save",
      carregando: false,
      atualizando: false,
      status: {},
      statuss: [], // [] lista
      barra_inicial: 0,
      barra_limite: 60000 * 5, // temporizador 60.000 milisegundos refere-se a 1 minutos

      fieldsescaladiaria: [
        { key: "linha", label: "Linha", sortable: true },
        { key: "tabela", label: "Tabela", sortable: true },
        { key: "servico_ini", label: "Jornada_início", sortable: true },
        { key: "servico_ter", label: "Jornada_Término", sortable: true },
        { key: "refeicao_ini", label: "Refeição_início", sortable: true },
        { key: "refeicao_ter", label: "Refeição_Término", sortable: true },
        { key: "lote", label: "Lote", sortable: true },
        { key: "motprogramado", label: "MotProg", sortable: true },
        { key: "motrealizado", label: "Mot_Real", sortable: true },
        { key: "cobprogramado", label: "Cob_Prog", sortable: true },
        { key: "cobrealizado", label: "Cob_Real", sortable: true },
        { key: "carroprogramado", label: "Carro_Prog", sortable: true },
        { key: "carrorealizado", label: "Carro_Real", sortable: true },
        { key: "status", label: "Status", sortable: true },
        {
          key: "dt_alteracao",
          label: "Data_alteração",
          sortable: true,
          formatter: (value, key, escalaservico) => {
            return moment(escalaservico.dt_alteracao)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },

        { key: "actions", label: "Ações" },
      ],
    };
  },

  components: {
    Multiselect,
  },
  methods: {
    getBackgroundColor(item) {
      console.log("Mostra item: ", item);

      if (item.motprogramado && item.motrealizado) {
        const result =
          item.motprogramado === item.motrealizado ? "bg-green" : "bg-yellow";
        console.log(
          "Mostra Mot: ",
          item.motprogramado,
          item.motrealizado,
          result
        );
        return result;
      }
      /*
  else if (item.cobprogramado && item.cobrealizado) {
    const result = item.cobprogramado === item.cobrealizado ? 'bg-green' : 'bg-yellow';
    console.log("Mostra Cob: ", item.cobprogramado, item.cobrealizado, result);
    return result;
  }
  else if (item.carroprogramado && item.carrorealizado) {
    const result = item.carroprogramado === item.carrorealizado ? 'bg-green' : 'bg-yellow';
    console.log("Mostra Carro: ", item.carroprogramado, item.carrorealizado, result);
    return result;
  }
  */

      console.log("Mostra No match: ", item);
      return ""; // Caso uma das células não esteja preenchida, não aplicamos cor de fundo
    },

    getBackgroundColorCobrador(item) {
      if (item.cobprogramado && item.cobrealizado) {
        const result =
          item.cobprogramado === item.cobrealizado ? "bg-green" : "bg-yellow";
        console.log(
          "Mostra Carro: ",
          item.cobprogramado,
          item.cobrealizado,
          result
        );
        return result;
      }

      console.log("Mostra No match: ", item);
      return ""; // Caso uma das células não esteja preenchida, não aplicamos cor de fundo
    },
    getBackgroundColorCarro(item) {
      if (
        (item.carroprogramado && item.carrorealizado) ||
        !item.carroprogramado
      ) {
        const result =
          item.carroprogramado === item.carrorealizado
            ? "bg-green"
            : "bg-yellow";
        console.log(
          "Mostra Carro: ",
          item.carroprogramado,
          item.carrorealizado,
          result
        );
        return result;
      }

      console.log("Mostra No match: ", item);
      return ""; // Caso uma das células não esteja preenchida, não aplicamos cor de fundo
    },

    temporizador() {
      this.handle = setInterval(() => {
        this.barra_inicial = this.barra_inicial + 1000;
        if (this.barra_inicial >= this.barra_limite) {
          this.barra_inicial = 0;
          this.loadescalaservico(),
            this.getBackgroundColor(),
            this.getBackgroundColorCarro(),
            this.getBackgroundColorCobrador();
        }
      }, 1000);
    },

    loadEmpresas() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios.get(url, { params }).then((res) => {
        this.empresas = res.data.map((empresa) => {
          return {
            id_empresa: empresa.id_empresa,
            empresa: empresa.nomeempresarial,
          };
        });
      });
    },

    loadFiliais() {
      let params = {
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/ctr/empresa/filial`;
      axios.get(url, { params }).then((res) => {
        this.filiais = res.data.map((filial) => {
          return { id_filial_erp: filial.id_filial_erp, filial: filial.filial };
        });
      });
    },

    loadStatus() {
      let params = {
        id_grupo: `${this.user.id_grupo}`,
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/escala/status`;
      axios.get(url, { params }).then((res) => {
        this.statuss = res.data.map((sta) => {
          return { ...sta, value: sta.id_status, status: sta.status };
        });
      });
    },

    loadLote() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/escala/lote`;
      axios
        .get(url, { params })
        .then((res) => {
          this.lotes = res.data.map((lot) => {
            return { id_lote: lot.id_lote, lote: lot.lote };
          });
        })
        .catch(showError);
    },

    loadLinhas() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.valor_filial.map((l) => l.id_filial_erp)}`,
        id_lote: `${this.valor_lote.map((l) => l.id_lote)}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/linha/cad`;
      axios
        .get(url, { params })
        .then((res) => {
          this.linhas = res.data.map((lin) => {
            return { ...lin, value: lin.id_linha, linha: lin.linha }; //// para pegar o valor tem que usar o ... atribuicao value
          });
        })
        .catch(showError);
    },

    loadMotivoAlteracaoCarro() {
      let params = {
        id_grupo: `${this.user.id_grupo}`,
        empresa_id: `${this.user.id_empresa}`,
        destino_id: 2,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/escala/alteracao/motivo`;
      axios.get(url, { params }).then((res) => {
        this.motivosalteracoesCarro = res.data.map((mot) => {
          return {
            ...mot,
            value: mot.id,
            motivo: mot.motivo,
            falta: mot.falta,
          };
        });
      });
    },

    loadMotivoAlteracaoCobrador() {
      let params = {
        id_grupo: `${this.user.id_grupo}`,
        empresa_id: `${this.user.id_empresa}`,
        destino_id: 1,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/escala/alteracao/motivo`;
      axios.get(url, { params }).then((res) => {
        this.motivosalteracoesCobrador = res.data.map((mot) => {
          return {
            ...mot,
            value: mot.id,
            motivo: mot.motivo,
            falta: mot.falta,
          };
        });
      });
    },

    loadMotivoAlteracaoMotorista() {
      let params = {
        id_grupo: `${this.user.id_grupo}`,
        empresa_id: `${this.user.id_empresa}`,
        destino_id: 1,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };
      const url = `${baseApiUrl}/planejamento/escala/alteracao/motivo`;
      axios.get(url, { params }).then((res) => {
        this.motivosalteracoesMotorista = res.data.map((mot) => {
          return {
            ...mot,
            value: mot.id,
            motivo: mot.motivo,
            falta: mot.falta,
          };
        });
      });
    },

    loadEscalaServico() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.valor_filial.map((l) => l.id_filial_erp)}`,
        id_lote: `${this.valor_lote.map((l) => l.id_lote)}`,
        id_linha: `${this.valor_linha.map((l) => l.id_linha)}`,
        id_status: `${this.valor_status.map((l) => l.id_status)}`,
        dt_servico: `${this.valor_dtservico}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/planejamento/escala/monitoramento`;
      axios.get(url, { params }).then((res) => {
        this.carregando = false;
        this.loadEscalaServicoAlteracoes();
        this.escalaservicos = res.data.map((ed) => {
          return { ...ed };
        });
      });
    },

    // contador alteracoes escala diaria
    loadEscalaServicoAlteracoes() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.valor_filial.map((l) => l.id_filial_erp)}`,
        dt_servico: `${this.valor_dtservico}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/planejamento/escala/diariaalteracoes`;
      axios.get(url, { params }).then((res) => {
        this.escalaservicosalteracoes = res.data;
        //this.carregando = false;
        //this.escalaservicosalteracoes = res.data.map(ed => {               return { ... ed}             })
      });
    },

    editTabela(escalaservico) {
      this.escalaservico = { ...escalaservico };
    },
    resetEditTabela() {
      this.valor_carro = "";
      this.valor_cobrador = "";
      this.valor_motorista = "";
      this.escalaservico = [];
      this.escalaservicosalteracoes = [];
      this.carro = [];
      this.cobrador = [];
      this.motorista = [];
    },

    putTabelaDiaria() {
      let corpo = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id: `${this.escalaservico.id_escaladiaria}`,
        id_tabela: `${this.escalaservico.id_tabela}`,
        id_carro_real: `${this.carro}`
          ? `${this.carro.map((car) => car.id_veiculo).join(", ")}`
          : null,
        id_motorista_real:
          `${this.motorista.map((mt) => mt.id_funcionario)}` == ""
            ? null
            : `${this.motorista.map((mt) => mt.id_funcionario)}`,
        id_cobrador_real:
          `${this.cobrador.map((cb) => cb.id_funcionario)}` == ""
            ? null
            : `${this.cobrador.map((cb) => cb.id_funcionario)}`,
        id_funcionario_monitoramento: `${this.user.id_funcionario}`,
      };
      const url = `${baseApiUrl}/planejamento/escala/alteracao`;
      axios
        .post(url, corpo)
        .then(() => {
          //this.putTabelaDiariaPartidas()
          //       this.$toasted.global.defaultSuccess()
        })
        .catch(showError);
    },

    putTabelaDiariaPartidas() {
      let corpo = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id_servico: `${this.escalaservico.id_escaladiaria}`,
        dt_servico: `${this.escalaservico.dt_servico}`,
        id_tabela: `${this.escalaservico.id_tabela}`,
        id_carro_real: `${this.carro}`
          ? `${this.carro.map((car) => car.id_veiculo).join(", ")}`
          : null,
        id_motorista_real:
          `${this.motorista.map((mt) => mt.id_funcionario)}` == ""
            ? null
            : `${this.motorista.map((mt) => mt.id_funcionario)}`,
        id_cobrador_real:
          `${this.cobrador.map((cb) => cb.id_funcionario)}` == ""
            ? null
            : `${this.cobrador.map((cb) => cb.id_funcionario)}`,
        id_funcionario_alteracao: `${this.user.id_funcionario}`,
        id_status: 1,
      };
      const url = `${baseApiUrl}/planejamento/escala/alteracao/partidas`;
      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.loadEscalaServico();
        })
        .catch(showError);
    },

    putTabelaDiariaTransacao() {
      let corpo = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        grupo_empresa_id: `${this.user.id_grupo_empresa}`,
        empresa_id: `${this.user.id_empresa}`,
        filial_id: `${this.escalaservico.id_filial}`,
        servico_id: `${this.escalaservico.id_escaladiaria}`,
        tabela_id: `${this.escalaservico.id_tabela}`,
        linha_id: `${this.escalaservico.id_linha}`,
        dt_servico: `${this.escalaservico.dt_servico}`,
        funcionario_monitoramento_id: `${this.user.id_funcionario}`,

        carro_prog_id: `${this.escalaservico.id_carro_prog}`,
        carro_real_id: `${this.carro}`
          ? `${this.carro.map((car) => car.id_veiculo).join(", ")}`
          : null,
        motorista_prog_id: `${this.escalaservico.id_motorista_prog}`,
        motorista_real_id:
          `${this.motorista.map((mt) => mt.id_funcionario)}` == ""
            ? null
            : `${this.motorista.map((mt) => mt.id_funcionario)}`,

        cobrador_prog_id: `${this.escalaservico.id_cobrador_prog}`,
        cobrador_real_id:
          `${this.cobrador.map((cb) => cb.id_funcionario)}` == ""
            ? null
            : `${this.cobrador.map((cb) => cb.id_funcionario)}`,
        falta_cob: !!this.motivoSelecionadoCobrador?.falta,
        falta_mot: !!this.motivoSelecionadoMotorista?.falta,
      };
      const url = `${baseApiUrl}/planejamento/escala/alteracao/operacional`;
      axios
        .put(url, corpo)
        .then(() => {
          this.postTabelaDiarialog(),
            this.resetEditTabela(),
            this.loadEscalaServico();
        })
        .catch(showError);
    },

    postTabelaDiarialog() {
      let corpo = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id_empresa_grupo: `${this.user.id_grupo_empresa}`,
        id_empresa: `${this.user.id_empresa}`,
        id_filial: `${this.escalaservico.id_filial}`,
        id_servico: `${this.escalaservico.id_escaladiaria}`,
        id_linha: `${this.escalaservico.id_linha}`,
        id_tabela: `${this.escalaservico.id_tabela}`,
        dt_servico: `${this.escalaservico.dt_servico}`,
        id_carro_prog:
          `${this.escalaservico.id_carro_prog}` == null
            ? ""
            : `${this.escalaservico.id_carro_prog}`,
        id_carro_real:
          `${this.carro.map((cr) => cr.id_veiculo)}` == ""
            ? null
            : `${this.carro.map((cr) => cr.id_veiculo)}`,
        id_carro_mot: `${this.escalaservico.id_motivo_carro}`,
        id_mot_prog:
          `${this.escalaservico.id_motorista_prog}` == null
            ? ""
            : `${this.escalaservico.id_motorista_prog}`,
        id_mot_real:
          `${this.motorista.map((mt) => mt.id_funcionario)}` == "" ||
          `${this.motorista.map((mt) => mt.id_funcionario)}` == null
            ? null
            : `${this.motorista.map((mt) => mt.id_funcionario)}`,
        id_mot_mot: `${this.escalaservico.id_motivo_motorista}`,
        id_cob_prog:
          `${this.escalaservico.id_cobrador_prog}` == null
            ? ""
            : `${this.escalaservico.id_cobrador_prog}`,
        id_cob_real:
          `${this.cobrador.map((cb) => cb.id_funcionario)}` == ""
            ? null
            : `${this.cobrador.map((cb) => cb.id_funcionario)}`,
        id_cob_mot: `${this.escalaservico.id_motivo_cobrador}`,
        id_funcionario_alteracao: `${this.user.id_funcionario}`,
        id_origem: 1, //1 = web gestão operação  | 2 = app fiscalização | 3 = app liberaçaõ de frota
      };
      const url = `${baseApiUrl}/planejamento/escala/alteracao/log`;
      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
        })
        .catch(showError);
    },

    loadVeiculo() {
      let params = {
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
        id_empresa: `${this.user.id_empresa}`,
        prefixo: `${this.valor_carro}`,
      };
      const url = `${baseApiUrl}/manutencao/frota/veiculo`;
      axios
        .get(url, { params })
        .then((res) => {
          this.carro = res.data;
        })
        .catch(showError);
    },

    async loadBuscaMotorista() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        registro: `${this.valor_motorista}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/folha/funcionario/busca`;

      try {
        const res = await axios.get(url, { params });

        // Como você só espera um motorista, diretamente atribui o valor
        this.motorista = [res.data]; // Colocando dentro de um array
      } catch (error) {
        console.error("Erro ao carregar motoristas:", error);
      }
    },

    async loadBuscaCobrador() {
      let params = {
        id_empresa: `${this.user.id_empresa}`,
        registro: `${this.valor_cobrador}`,
        psg: this.user.psg, // Adiciona o 'psg' nos parâmetros
      };

      const url = `${baseApiUrl}/folha/funcionario/busca`;

      try {
        const res = await axios.get(url, { params });

        // Como você só espera um motorista, diretamente atribui o valor
        this.cobrador = [res.data]; // Colocando dentro de um array
      } catch (error) {
        console.error("Erro ao carregar motoristas:", error);
      }
    },

    limparFiltro() {
      this.search = "";
    },
  },

  mounted() {
    this.loadEmpresas();
    this.loadStatus();
    this.loadMotivoAlteracaoCarro();
    this.loadMotivoAlteracaoCobrador();
    this.loadMotivoAlteracaoMotorista();
    this.loadEscalaServicoAlteracoes();
    this.temporizador();
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
.card-modern-left-line {
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
  border: none;
  background-color: #f8f9fa; /* Cor de fundo suave */
}

.card-modern-left-line:hover {
  transform: translateY(-5px);
}

.card-modern-left-line::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 8px;
  height: 100%;
  background: linear-gradient(
    to top,
    #28a745,
    #218838
  ); /* Gradiente de verde para a linha */
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  transition: background 0.3s ease-in-out;
}

.card-modern-left-line:hover::before {
  background: linear-gradient(
    to top,
    #007bff,
    #0056b3
  ); /* Exemplo: azul no hover */
}

/* Estilo para o cabeçalho do card */
.card-modern-left-line .card-header {
  background-color: transparent; /* Fundo transparente */
  color: #343a40; /* Cor do texto mais escura */
  font-weight: bold;
  border-bottom: none;
  padding: 1rem;
  border-top-right-radius: 15px;
}

/* Estilo para o ícone no cabeçalho */
.card-modern-left-line .card-header .b-icon {
  color: #343a40; /* Cor do ícone, pode ser a mesma do texto ou uma cor de destaque */
}

/* Ajuste para o texto dentro do card-body */
.card-modern-left-line .card-body {
  padding: 1.5rem;
}

/* Estilo para o texto do contador */
.card-modern-left-line h2 {
  color: #343a40;
  margin-top: 1rem;
}

/* Classe para a sombra com gradiente */
.shadow-gradient {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.shadow-gradient:hover {
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15), 0 0 0 3px rgba(40, 167, 69, 0.2); /* Borda "brilho" da cor principal */
}

/* css para comparar a cor entre as celulas alteradas */
.bg-green {
  background-color: #cfefd1;
}

.bg-yellow {
  background-color: yellow;
}

.bg-red {
  background-color: red;
}

/* Define o tamanho da fonte para todos os elementos dentro da tabela com o ID */
#escaladiariamonitoramento {
  font-size: 0.9rem; /* Exemplo: 80% do tamanho padrão ou 14px */
}

/* Ou, para ser mais específico (se necessário) */
#escaladiariamonitoramento th,
#escaladiariamonitoramento td {
  font-size: 0.8rem; /* Aplica aos cabeçalhos (th) e células (td) */
}
</style>